<template>
  <v-card
    rounded="0"
    theme="dark"
    min-height="100%"
    class="bg-dark mx-auto"
  >
    <div>
      <div style="height: 100px" class="d-flex justify-content-center align-items-center">
        <v-img v-show="expanded" transition="fade-transition" :src="logo" style="max-width: 190px" :title="version" />

        <v-img v-show="!expanded" transition="fade-transition" :src="logoMini" contain height="40%" :title="version" />
      </div>

      <v-divider class="mt-0"></v-divider>
    </div>

    <DialogAlert
      :open="false"
      title="Validacion requerida"
      message="Su cuenta requiere una validación administrativa. Por favor, comuníquese con el responsable del sistema para continuar operando con normalidad."
      @close="dialog_alert = false"
    />

    <div style="scroll-margin-top: 100px" v-for="item in items" :key="item.title">
      <v-list density="default" class="pt-1 pb-1" v-if="item.visible" nav>
        <v-list-group v-if="item.visible && 'items' in item && item.items.length > 0" v-model="item.active" :key="item.title" no-action>
          <template v-slot:activator="{ props }">
            <v-list-item dense v-bind="props" :title="item.title">
              <template v-slot:prepend> <font-awesome-icon :icon="item.icon" class="sidebar-icon mr-1" /> </template>
            </v-list-item>
          </template>

          <router-link v-for="subItem in item.items" :key="subItem.title" :to="'/' + subItem.path">
            <v-list-item :class="expanded ? 'subitem text-white' : 'subitem text-white hidden'" v-if="subItem.visible" ripple @click="close">
              <template v-slot:prepend>
                <font-awesome-icon v-if="subItem.icon != ''" :icon="subItem.icon" class="sidebar-icon mr-1" />
              </template>
              <v-list-item-title>{{ subItem.title }}</v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list-group>

        <router-link v-else-if="item.visible" :to="'/' + item.path">
          <v-list-item :active="isActiveItem(item.path)" dense class="text-white pl-1" :key="item.title" link>
            <template v-slot:prepend> <font-awesome-icon :icon="item.icon" class="sidebar-icon mr-1" /> </template>

            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list>
    </div>
  </v-card>
</template>

<script>
import Constant from "@/constants/sections";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { version } from "../../package.json";
import DialogAlert from "@/components/DialogAlert.vue";
export default {
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  components: { DialogAlert },
  props: {
    //Lo calcula App.vue a partir del breakpoint, de `sidebar.open` y del hover del drawer.
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      version: version,
      isExternal: null,
      clientItems: [
        /*{ title: "Monitoreo", icon: "desktop", path: Constant.SECTION_MONITORING, visible: false, active: false },*/
        {
          title: "Recepción",
          icon: "arrow-right",
          active: false,
          visible: false,
          items: [{ title: "ASN", icon: "", path: Constant.SECTION_ASN, visible: false }],
        },
        {
          title: "Expedición",
          icon: "arrow-left",
          active: false,
          visible: false,
          items: [
            { title: "Ordenes de envio", icon: "", path: Constant.SECTION_SHIPMENT_ORDERS, visible: false },
            { title: "Olas de preparacion", icon: "", path: Constant.SECTION_WAVE, visible: false },
            { title: "Punto de entrega", icon: "", path: Constant.SECTION_SUBCLIENTS, visible: false },
          ],
        },
        {
          title: "Inventario",
          icon: "boxes-stacked",
          active: false,
          visible: false,
          items: [
            { title: "Inventario", icon: "", path: Constant.SECTION_INVENTORY + "/atributos", visible: false },
            { title: "Inventario por LPN", icon: "", path: Constant.SECTION_INVENTORY + "/lpn", visible: false, client_flag: "view_inventory_lpn" },
            { title: "Productos", icon: "", path: Constant.SECTION_PRODUCTS, visible: false },
            { title: "Rubros", icon: "", path: Constant.SECTION_RUBROS, visible: false },
            { title: "Subrubros", icon: "", path: Constant.SECTION_SUBRUBROS, visible: false },
            { title: "Proveedores", icon: "", path: Constant.SECTION_SUPPLIER, visible: false },
          ],
        },
        { title: "Reportes", icon: "file", path: Constant.SECTION_REPORTS, visible: false, active: false },
      ],
      allItems: [
        { title: "Monitoreo", icon: "desktop", path: Constant.SECTION_MONITORING, visible: false, active: false },
        {
          title: "Recepción",
          icon: "arrow-right",
          active: false,
          visible: false,
          items: [{ title: "ASN", icon: "", path: Constant.SECTION_ASN, visible: false }],
        },
        {
          title: "Expedición",
          icon: "arrow-left",
          active: false,
          visible: false,
          items: [
            { title: "Ordenes de envio", icon: "", path: Constant.SECTION_SHIPMENT_ORDERS, visible: false },
            { title: "Olas de preparacion", icon: "", path: Constant.SECTION_WAVE, visible: false },
            { title: "Preparación de envios", icon: "", path: Constant.SECTION_PICKING_DETAIL, visible: false },
            { title: "Gestion de picking", icon: "", path: Constant.SECTION_PICKING_MANAGEMENT, visible: false },
            { title: "Empaquetar", icon: "", path: Constant.SECTION_PACKAGES, visible: false },
          ],
        },
        { title: "Tareas", icon: "list-check", path: Constant.SECTION_TASKS, visible: false, active: false },
        { title: "Incidencias", icon: "triangle-exclamation", path: Constant.SECTION_INCIDENCIAS, visible: false, active: false },
        {
          title: "Inventario",
          icon: "boxes-stacked",
          active: false,
          visible: false,
          items: [
            { title: "Por LPN", icon: "", path: Constant.SECTION_INVENTORY + "/lpn", visible: false },
            { title: "Por Ubicacion", icon: "", path: Constant.SECTION_INVENTORY + "/ubicacion", visible: false },
            { title: "Por Atributos", icon: "", path: Constant.SECTION_INVENTORY + "/atributos", visible: false },
            { title: "Ajuste manual", icon: "", path: Constant.SECTION_AJUSTE_MANUAL, visible: false },
            { title: "Conteo ciclico", icon: "", path: Constant.SECTION_CONTEO, visible: false },
          ],
        },
        { title: "LPNs", icon: "barcode", path: Constant.SECTION_LPN, visible: false, active: false },
        {
          title: "Productos",
          icon: "box",
          path: Constant.SECTION_PRODUCTS,
          visible: false,
          active: false,
          items: [
            { title: "Productos", icon: "", path: Constant.SECTION_PRODUCTS, visible: false },
            { title: "Rubros", icon: "", path: Constant.SECTION_RUBROS, visible: false },
            { title: "Subrubros", icon: "", path: Constant.SECTION_SUBRUBROS, visible: false },
            { title: "Proveedores", icon: "", path: Constant.SECTION_SUPPLIER, visible: false },
            { title: "Tipos de producto", icon: "", path: Constant.SECTION_PRODUCT_TYPES, visible: false },
            { title: "Reglas", icon: "", path: Constant.SECTION_RULES, visible: false },
          ],
        },
        {
          title: "Clientes",
          icon: "users",
          active: false,
          visible: false,
          items: [
            { title: "Clientes", icon: "", path: Constant.SECTION_CLIENTS, visible: false },
            { title: "Punto de entrega", icon: "", path: Constant.SECTION_SUBCLIENTS, visible: false },
          ],
        },
        { title: "Reportes", icon: "file", path: Constant.SECTION_REPORTS, visible: false, active: false },
        {
          title: "Administrar",
          icon: "cog",
          active: false,
          visible: false,
          items: [
            { title: "Sucursales", icon: "", path: Constant.SECTION_SUCURSALES, visible: false }, //building
            { title: "Almacenes", icon: "", path: Constant.SECTION_ALMACENES, visible: false }, //warehouse
            { title: "Zonas", icon: "", path: Constant.SECTION_ZONAS, visible: false }, //signs-post
            { title: "Ubicaciones", icon: "", path: Constant.SECTION_UBICACIONES, visible: false }, //signs-post
            { title: "Categorias de zonas", icon: "", path: Constant.SECTION_CATEGORIAS_ZONAS, visible: false }, //layer-group
            { title: "Tipos de ubicaciones", icon: "", path: Constant.SECTION_TIPOS_UBICACIONES, visible: false }, //layer-group
            { title: "Tipos de recepciones", icon: "", path: Constant.SECTION_TIPOS_RECEPCION, visible: false }, //layer-group
            { title: "Tipos de Cubicaje", icon: "", path: Constant.SECTION_CUBICATION_TYPES, visible: false },
            { title: "Muelles", icon: "", path: Constant.SECTION_DOCKS, visible: false },
            { title: "Impresoras", icon: "", path: Constant.SECTION_PRINTERS, visible: false },
            { title: "Colaboradores", icon: "", path: Constant.SECTION_EMPLOYEES, visible: false }, //user
            { title: "Operarios", icon: "", path: Constant.SECTION_OPERATORS, visible: false }, //user
            { title: "Roles", icon: "", path: Constant.SECTION_ROLES, visible: false }, //user-cog
            { title: "Webhooks", icon: "", path: Constant.SECTION_WEBHOOKS, visible: false }, //bolt
            { title: "Configuraciones", icon: "", path: Constant.SECTION_SETTINGS, visible: false }, //user-cog
          ],
        },
      ],
      dialog_alert: true,
      items: [],
      logoMini: require("@/assets/images/logo-mini.png"),
    };
  },
  computed: {
    //Se toma del store (no de localStorage en data()) para que se actualice al cambiarlo
    //desde Configuraciones y para tener fallback si el backend no devolvio logo.
    logo() {
      return this.$store.state.logo || this.logoMini;
    },
  },
  mounted() {
    this.loadSideBarExternal();
    
    // Inicializar expandMenu según el dispositivo
    if (this.$vuetify.display.mdAndDown) {
      this.expandMenu = this.$store.state.sidebar.drawer;
    } else {
      this.expandMenu = this.$store.state.sidebar.open;
    }
  },
  watch: {
    "$store.state.sidebar.open": function () {
      if (this.$store.state.sidebar.open) {
        this.expandMenu = true;
      } else {
        this.expandMenu = false;
      }
    },
    "$store.state.sidebar.drawer": function () {
      // En mobile, el expandMenu se controla por drawer
      if (this.$vuetify.display.mdAndDown) {
        this.expandMenu = this.$store.state.sidebar.drawer;
      }
    },
    $route() {
      this.dialog_alert = true;
    },
  },
  methods: {
    // Un item de menu puede declarar `client_flag`: el nombre de un boolean del cliente
    // (llega en app_object, ver GenericMixin.getAppObject()) que debe estar en true para
    // mostrarse. Sin `client_flag` no hay restricción adicional.
    hasClientFlag(flag) {
      if (!flag) return true;
      return this.getAppObject()?.[flag] === true;
    },
    handleExpandMenu(value) {
      // En mobile no expandir automáticamente por hover
      if (this.$vuetify.display.mdAndDown) {
        this.expandMenu = this.$store.state.sidebar.drawer;
        return;
      }
      
      if (this.$store.state.sidebar.open) {
        this.expandMenu = true;
      } else {
        this.expandMenu = value;
      }
    },
    isActiveItem(path) {
      return path != null && this.$route.path.startsWith("/" + path);
    },
    close() {
      // En mobile, cerrar el drawer al hacer click en un item. No se toca `open`, que solo
      // define expandido/rail en desktop y se persiste entre sesiones.
      if (this.$vuetify.display.mdAndDown) {
        this.$store.commit("setOpenSidebar", { drawer: false });
      }
    },
    loadSideBarExternal() {
      this.items = this.getItemsAvailable();
    },
    getItemsSideBar() {
      let items = [];
      if (this.isClient()) {
        items = this.clientItems;
      }

      if (this.isEmployee()) {
        items = this.allItems;
      }

      return items;
    },
    getItemsAvailable() {
      let itemsAvailable = JSON.parse(JSON.stringify(this.getItemsSideBar()));
      //console.log("ROLES SIDEBAR:", itemsAvailable);

      itemsAvailable.forEach((item) => {
        if ("items" in item) {
          let any_visible = false;
          item.items.forEach((sub_item) => {
            sub_item.visible =
              sub_item.path.split("/")[0] in this.roles &&
              this.roles[sub_item.path.split("/")[0]].sidebar &&
              this.hasClientFlag(sub_item.client_flag);
            if (sub_item.visible) any_visible = true;

            //hardcodee para dev
            //sub_item.visible = true;
          });
          item.visible = any_visible;
        } else {
          item.visible = item.path in this.roles && this.roles[item.path].sidebar && this.hasClientFlag(item.client_flag);
        }
        //hardcodee para dev
        //item.visible = true;
      });
      return itemsAvailable;
    },
  },
};
</script>
